import { UnderlyingBadge } from 'components/common-form/sidePanel/info/UnderlyingBadge';
import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { IntlKey } from 'locales';
import { FormErrorSeverity, UnderlyingFormError } from 'models/formError';
import { FormattedDate } from 'react-intl';

type UnderlyingValidationErrorsProps = {
  severity?: FormErrorSeverity;
  underlyingValidationErrors?: readonly UnderlyingFormError[];
  errorPrefix?: string;
};

const UnderlyingValidationErrors: React.FC<UnderlyingValidationErrorsProps> = ({
  underlyingValidationErrors,
  severity,
  errorPrefix,
}) => {
  if (!underlyingValidationErrors || underlyingValidationErrors.length === 0) {
    return null;
  }

  return (
    <div className={`d-flex flex-wrap alert alert-discreet-${lessAgressiveColorMapper(severity!)} fw-semibold p-2`}>
      {underlyingValidationErrors?.map((underlyingValidationError, i) => (
        <>
          <div
            key={underlyingValidationError.underlying.id}
            className="d-flex gap-1"
            data-e2e="underlying-validation-error"
          >
            <UnderlyingBadge underlying={underlyingValidationError.underlying} />
            {underlyingValidationError.translationKey && (
              <span>
                <FormattedMessage id={`${errorPrefix}${underlyingValidationError.translationKey}` as IntlKey} />
              </span>
            )}
            {underlyingValidationError.underlying.expiryDate && (
              <span>
                <FormattedDate
                  value={underlyingValidationError.underlying.expiryDate}
                  year="numeric"
                  month="short"
                  day="numeric"
                />
              </span>
            )}
          </div>
          {i !== underlyingValidationErrors!.length - 1 && <div>,&nbsp;</div>}
        </>
      ))}
    </div>
  );
};

export default UnderlyingValidationErrors;
